import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-maps-google',
  templateUrl: './maps-google.component.html',
  styleUrls: ['./maps-google.component.scss']
})
export class MapsGoogleComponent implements OnInit  {

  constructor() {}

  ngOnInit()
  {

  }
}